module.exports = __webpack_public_path__ + "img/1160_MILR_Website_HighLife_05_2.a01526eb.png";